import React from 'react';
import PropTypes from 'prop-types';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

function GiftVoucherPagination({page, totalPages, onChange, primaryColor}) {
  if (totalPages <= 1) return null;
  return (
    <Stack alignItems="center" sx={{mt: 2, mb: 2}}>
      <Pagination
        count={totalPages}
        page={page}
        onChange={onChange}
        sx={{
          '& .MuiPaginationItem-root': {
            cursor: 'pointer',
            borderRadius: 2,
            fontWeight: 600,
            color: primaryColor ? primaryColor : 'primary.main',
          },
          '& .MuiPaginationItem-root.Mui-selected': {
            backgroundColor: primaryColor ? `${primaryColor} !important` : 'primary.main',
            color: '#fff !important',
          },
          '& .MuiPaginationItem-root.Mui-selected:hover': {
            backgroundColor: primaryColor ? `${primaryColor} !important` : 'primary.main',
            opacity: 0.85,
          },
        }}
      />
    </Stack>
  );
}

GiftVoucherPagination.propTypes = {
  page: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  primaryColor: PropTypes.string,
};

export default GiftVoucherPagination;
